import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import * as React from 'react';
function Card({ className, ref, ...props }) {
    return (_jsx("div", { ref: ref, className: cn('border-border bg-card text-card-foreground rounded-lg border shadow-sm', className), ...props }));
}
function CardHeader({ className, ref, ...props }) {
    return _jsx("div", { ref: ref, className: cn('flex flex-col space-y-1.5 p-6', className), ...props });
}
function CardTitle({ className, ref, children, ...props }) {
    return (_jsx("h3", { ref: ref, className: cn('text-2xl leading-none font-semibold tracking-tight', className), ...props, children: children }));
}
function CardDescription({ className, ref, ...props }) {
    return _jsx("p", { ref: ref, className: cn('text-muted-foreground text-sm', className), ...props });
}
function CardContent({ className, ref, ...props }) {
    return _jsx("div", { ref: ref, className: cn('p-6 pt-0', className), ...props });
}
function CardFooter({ className, ref, ...props }) {
    return _jsx("div", { ref: ref, className: cn('flex items-center p-6 pt-0', className), ...props });
}
export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle };
